import React from 'react';
import { DefaultShipping } from '../partials/shipping/DefaultShipping';
import { NoStoreOption } from '../partials/store/NoStoreOption';
import { GCC_COUNTER_TOPS } from '../../components/constants';
import {
  getShippingThreshold,
  getSellableQuantityYourStore,
  isAppliance,
  isBackordered,
  isBODFS,
  isDiscontinued,
  hasFreeShipping,
  isLiveGoods,
  isNextDayDelivery,
  isOutOfStockOnline,
  isSameDayDelivery,
  isSTH,
  shouldShowShippingThreshold,
  meetsApplianceDeliveryThreshold
} from './pod-fulfillment-utils';

export const getShippingTemplate = ({ product }) => {

  const isGCCCounter = product?.info
    .globalCustomConfigurator?.customExperience === GCC_COUNTER_TOPS;

  if (!product || isGCCCounter) return null;

  /* -----LiveGoods----- */
  if (isLiveGoods(product) && !getSellableQuantityYourStore(product)) {
    return null;
  }

  if (isDiscontinued(product)) {
    return () => <NoStoreOption storeMessage="No longer available" enableNearbyStore={false} />;
  }
  /* -----Appliance----- */
  if (isAppliance(product)) {

    if (meetsApplianceDeliveryThreshold(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Free Delivery"
        />
      );
    }

    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Free delivery on appliance purchases of $396 and up"
      />
    );
  }
  /* -----STH Only----- */
  if (isSTH(product) && !isBODFS(product)) {
    if (isBackordered(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Standard Delivery"
        />
      );
    }
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Free delivery"
        />
      );
    }
    if (getShippingThreshold(product)) {
      let shippingMessage = shouldShowShippingThreshold(product, getShippingThreshold(product))
        ? `Free delivery with $${getShippingThreshold(product)} order`
        : 'Free Delivery';
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage={shippingMessage}
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Standard Delivery"
      />
    );
  }
  /* -----BODFS only----- */
  if (isBODFS(product) && !isSTH(product)) {
    // TODO: temporarily bypass same/next-day messaging for covid response
    /*
    if (isSameDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Same-day delivery"
        />
      );
    }
    if (isNextDayDelivery(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Next-day delivery"
        />
      );
    }
    */
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Schedule Delivery"
      />
    );
  }
  /* -----STH and BODFS----- */
  if (isBODFS(product) && isSTH(product)) {
    if (hasFreeShipping(product)) {
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage="Free Delivery"
        />
      );
    }
    if (getShippingThreshold(product)) {
      let shippingMessage = shouldShowShippingThreshold(product, getShippingThreshold(product))
        ? `Free delivery with $${getShippingThreshold(product)} order`
        : 'Free Delivery';
      return () => (
        <DefaultShipping
          alertType="success"
          shippingMessage={shippingMessage}
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="success"
        shippingMessage="Standard delivery"
      />
    );
  }
  /* -----ot STH not BODFS means no delivery to customer directly----- */
  if (!isBODFS() && !isSTH()) {
    if (isDiscontinued(product)) {
      return null;
    }
    if (isOutOfStockOnline(product)) {
      return () => (
        <DefaultShipping
          alertType="close"
          shippingMessage="Out of stock online"
        />
      );
    }
    return () => (
      <DefaultShipping
        alertType="close"
        shippingMessage="Delivery unavailable"
      />
    );
  }

  return () => null;
};
